/* routes.js — Deux modes : l'analyse (#/) et la comparaison (#/comparer). Les
 * anciennes adresses de parcours mènent à l'analyse, sur le bloc correspondant.
 * Textes du guidage dans la page (#guideTexts). Expose window.Routes. */
(function () {
  'use strict';

  // ancienne adresse → bloc du résultat
  var LEGACY = { verifier: 'conformity', qualite: 'gaps', corriger: 'fixes' };
  var F = window.MediaFormat;
  var guide = document.getElementById('guide');
  var guideMsg = document.getElementById('guideMsg');
  var guideBody = document.getElementById('guideBody');
  var focusBlock = null; // bloc à montrer au prochain résultat

  function current() {
    var m = location.hash.match(/^#\/([a-z]+)/);
    return m && m[1] === 'comparer' ? 'comparer' : 'home';
  }

  function text(key, params) {
    var el = document.querySelector('#guideTexts [data-guide="' + key + '"]');
    return el.textContent.replace(/\{(\w+)\}/g, function (m, k) { return params && params[k] != null ? params[k] : m; });
  }

  function showGuide(msg, bodyHtml) {
    guideMsg.textContent = msg;
    guideBody.innerHTML = bodyHtml || '';
    guide.hidden = false;
  }
  function hideGuide() { guide.hidden = true; guideMsg.textContent = ''; guideBody.innerHTML = ''; }

  /* ---------- Changement de mode ---------- */
  function apply() {
    var m = location.hash.match(/^#\/([a-z]+)/);
    if (m && LEGACY[m[1]]) {
      focusBlock = LEGACY[m[1]];
      history.replaceState(null, '', location.pathname + location.search);
      if (window.App && window.App.hasFile()) { window.App.focus(focusBlock); focusBlock = null; }
    }
    var r = current();
    document.body.setAttribute('data-route', r);
    Array.prototype.forEach.call(document.querySelectorAll('[data-route]'), function (el) {
      if (el !== document.body) el.hidden = el.getAttribute('data-route') !== r;
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-nav]'), function (a) {
      if (a.getAttribute('data-nav') === r) a.setAttribute('aria-current', 'page');
      else a.removeAttribute('aria-current');
    });
    hideGuide();
    if (window.App) window.App.refreshEmpty();
    var b = document.getElementById('batch');
    if (r === 'comparer') {
      if (b) b.hidden = true;
      if (window.App) window.App.hide();
      if (window.Compare) window.Compare.show();
    } else {
      if (window.Compare) window.Compare.hide();
      if (window.App) window.App.rerender();
      if (b && window.Batch && window.Batch.isActive() && !(window.App && window.App.hasFile())) b.hidden = false;
    }
  }

  /* ---------- Fichiers déposés ---------- */
  function handleFiles(files) {
    hideGuide();
    if (current() === 'comparer') return window.Compare.receive(files);
    if (files.length === 1) return window.App.analyze(files[0]);
    if (files.length === 2) return twoFiles(files);
    window.Batch.start(files);
  }

  // Deux fichiers : deux versions à comparer, ou deux fichiers distincts ?
  function twoFiles(files) {
    showGuide(text('two'), '<button type="button" class="act tiny" data-two="compare">' + F.esc(text('compare-two')) + '</button> ' +
      '<button type="button" class="act tiny secondary" data-two="batch">' + F.esc(text('batch-two')) + '</button>');
    guideBody.onclick = function (e) {
      var b = e.target.closest('[data-two]');
      if (!b) return;
      hideGuide();
      if (b.getAttribute('data-two') === 'batch') return window.Batch.start(files);
      location.hash = '#/comparer';
      window.Compare.receive(files);
    };
  }

  window.Routes = {
    current: current, handleFiles: handleFiles, showGuide: showGuide, hideGuide: hideGuide, text: text,
      takeFocus: function () { var f = focusBlock; focusBlock = null; return f; }
  };

  window.addEventListener('hashchange', apply);
  apply();
})();
